import React from "react";

// Charte OFF MARKETTE : le K est toujours doré ; si le texte est entièrement
// doré (gold=true), le K devient blanc pour rester visible.
export const Brand = ({ gold = false, title = false, className = "" }) => (
  <span className={`${title ? "" : "font-semibold"} ${className}`}>
    {title ? (
      <>Off Mar<span className={gold ? "text-white" : "text-[#C19A6B]"}>k</span>ette</>
    ) : (
      <>OFF MAR<span className={gold ? "text-white" : "text-[#C19A6B]"}>K</span>ETTE</>
    )}
  </span>
);

export default Brand;
